// Imports
import Events from '@utilities/events';

/**
 * Update Gtm Listing Sort events
 *
 * @return {Void}
 */
const updateGtmListingSortEvents = function() {
  // constants
  const JS_HOOK_REFINEMENT_SORT = '[js-hook-refinement-sort]';
  const refinementSort = document.querySelector(JS_HOOK_REFINEMENT_SORT);

  if (refinementSort) {
    const refinementSortSelect = refinementSort.querySelector('#sort-order');
    const refinementSortButtons = [...refinementSort.querySelectorAll('.csb__button')];

    refinementSortButtons.forEach((refinementSortButton) => {
      const ferinementSortButtonLabel = refinementSortButton.querySelector('.csb__button-label') ? refinementSortButton.querySelector('.csb__button-label').innerText.replace(/\n/g, '') : null;

      refinementSortButton.addEventListener('click', () => {
        Events.$trigger('gtm::push', {
          data: {
            event: 'sort',
            label: ferinementSortButtonLabel
          }
        });
      })
    });

    refinementSortSelect.addEventListener('change', () => {
      const refinementSortSelectIndex = refinementSortSelect.selectedIndex;
      const selectedRefinement = refinementSortSelect.options[refinementSortSelectIndex];
      const selectedRefinementLabel = selectedRefinement.innerText.replace(/\n/g, '');

      Events.$trigger('gtm::push', {
        data: {
          event: 'sort',
          label: selectedRefinementLabel
        }
      });
    });
  }
};

export default updateGtmListingSortEvents;
